import React from 'react'
import classNames from 'classnames'

import Grid from '@material-ui/core/Grid'
import Fade from '@material-ui/core/Fade'
import IconButton from '@material-ui/core/IconButton'
import { withStyles, Typography, createStyles, WithStyles } from '@material-ui/core'

import { GamePrizeInfoResponse } from 'protos'
import { FormattedNumber } from 'react-intl'

import minusIconUrl from './assets/minus_icon.svg'
import plusIconUrl from './assets/plus_icon.svg'

interface Props {
  feeOptions: Array<GamePrizeInfoResponse.IFeeOption>
  onChange: (selectedIndex: number) => void
  selectedIndex: number
  className?: string
  isBalanceSufficient: boolean
}

const styles = createStyles({
  root: {
    width: 285,
  },
  icon: {
    width: 36,
    height: 36,
  },
  disabled: {
    opacity: 0.5,
  },
  currency: {
    fontSize: 13,
    fontWeight: 500,
    marginTop: 10,
    marginRight: 5
  },
  stake: {
    fontSize: 50,
    lineHeight: '59px',
    fontWeight: 500,
  },
})

type InjectedProps = Props & WithStyles<typeof styles>

const EntryFeePicker: React.SFC<InjectedProps> = ({
  feeOptions,
  onChange,
  selectedIndex,
  isBalanceSufficient,
  className,
  classes,
}) => {
  const hasNext = selectedIndex < feeOptions.length - 1
  const hasPrev = selectedIndex > 0
  const selectedEntryFee = Number(feeOptions[selectedIndex].entryFee!.value)

  return (
    <Grid container alignItems="center" className={classNames(className, classes.root)}>
      <Grid item>
        <IconButton disabled={!hasPrev} onClick={hasPrev ? () => { onChange(selectedIndex - 1) } : undefined}>
          <img alt="" src={minusIconUrl} className={classNames({ [classes.disabled]: !hasPrev, [classes.icon]: true })} />
        </IconButton>
      </Grid>
      <Grid item xs justify="center" container>
        <Fade in key={selectedEntryFee}>
          <Grid container justify="center" direction="row">
            <Grid item>
              <Typography variant="body1" color="textSecondary" className={classes.currency}>k</Typography>
            </Grid>
            <Grid item>
              <Typography
                className={classes.stake}
                color={isBalanceSufficient ? undefined : 'error'}
              >
                <FormattedNumber value={selectedEntryFee} />
              </Typography>
            </Grid>
          </Grid>
        </Fade>
      </Grid>
      <Grid item>
        <IconButton disabled={!hasNext} onClick={hasNext ? () => { onChange(selectedIndex + 1) } : undefined}>
          <img alt="" src={plusIconUrl} className={classNames({ [classes.disabled]: !hasNext, [classes.icon]: true })} />
        </IconButton>
      </Grid>
    </Grid>
  )
}

export default withStyles(styles)(EntryFeePicker)
